export default {
  // Set topics loaded state to true
  challengesLoaded(state) {
    state.challengesLoaded = String(Math.round(new Date().getTime() / 1000));
  },
  challengesTimestampReset(state) {
    state.challengesLoaded = null;
  },
  // Set content state
  challenges(state, payload) {
    state.challenges = payload;
  },
  // Set content state
  submissions(state, payload) {
    state.submissions = payload;
  },
};
